import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, logout as apiLogout, getCurrentUser, isLoggedIn } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isLoggedIn()) {
      const stored = getCurrentUser();
      setUser(stored);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const data = await apiLogin(username, password);
    const role = data.user_roles?.[0] || data.roles?.[0] || 'gpf_administrator';
    const userData = {
      name:           data.user_display_name,
      email:          data.user_email,
      id:             data.user_id,
      role:           role,
      avatar:         data.user_avatar      || '',
      workspace_slug: data.workspace_slug   || '',
    };
    localStorage.setItem('gpf_user', JSON.stringify(userData));
    setUser(userData);
    return data;
  };

  const logout = () => {
    apiLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoggedIn: !!user, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);